export const GET_RULE_REMEDIATION = "get_rule_remediation";
export const GET_RULE_REMEDIATION_SUCCESSFUL = "get_rule_remediation_successful";
export const GET_RULE_REMEDIATION_FAILED = "get_rule_remediation_failed";

export const CLEAR_ALL_RULE_REMEDIATION_MESSAGES = "clear_all_rule_remediation_messages";
export const CLEAR_ALL_RULE_REMEDIATION_MESSAGES_SUCCESSFUL =
  "clear_all_rule_remediation_messages_successful";